import {
   GET_STRUCTURE_TYPE_DOCUMENT,
   CHANGE_INPUT_VALUE_GENERAL_CONCEPT,
   CHANGE_INPUT_VALUE_CONCEPT,
   SELECTED_CUSTOMER,
   CHANGE_INPUT_VALUE_NOTES,
   LIST_DOCUMENTS_BY_TYPE,
   GET_DOCUMENT_INFORMATION,
   OPEN_CLOSE_MODAL,
   CHANGE_VALUE_SETTINGS,
   ACTIVATE_QUANTITY_CONCEPT,
   ACTIVATE_EXCHANGE_RATE,
   CHANGE_EXCHANGE_RATE,
   DISABLED_CONCEPT,
   DISABLED_GENERAL_CONCEPT,
   GET_CONCEPTS_LIKE_TREE,
   UPDATE_STATE_CONCEPTS_TREE,
   ASIGN_NEW_CONCEPT,
   CHANGE_VALUE_SPECIAL_INPUT,
   SAVE_NEW_DOCUMENT,
   MOVE_POSITION_CONCEPT,
   DELETE_DOCUMENT,
   MOVE_POSITION_GENERAL_CONCEPT,
   CHANGE_OPTION_SELECT_ISABI,
   GET_CONCEPTS_DISCOUNTS,
   CHANGE_STATE_CONCEPTS_DISCOUNTS,
   ASIGN_NEW_CONCEPT_DISCOUNT,
   CHANGE_VALUE_CONCEPT_DISCOUNT,
   CHANGE_POSITION_CONCEPTS_DISCOUNT,
   OPEN_CLOSE_MODAL_PAYMENT,
   CHANGE_VALUES_INPUTS_PAYMENT,
   SAVE_PAYMENT_DOCUMENT,
   GET_DETAILS_PAYMENT_DOCUMENT,
   CONFIRM_PAYMENT_DOCUMENT,
   LOAD_INFO_PAYMENT_FORM,
   UPLOAD_PICTURE_PAYMENT,
   DELETE_PAYMENT,
   FILTER_DOCUMENTS_BY_RANGE_DATES,
   CHANGE_SEARCH_INPUT_TABLE,
   RESET_SEARCH_INPUT_TABLE,
   FILTER_DOCUMENTS_BY_STATUS,
   CHANGE_ACCOUNT_BANK
} from '../constants/type_documents';

export const type_documents = ( state = {}, action ) => {
   switch ( action.type ) { 

      case GET_STRUCTURE_TYPE_DOCUMENT : {
         return action.payload;
      }

      case CHANGE_INPUT_VALUE_GENERAL_CONCEPT : {
         return action.payload;
      }

      case CHANGE_INPUT_VALUE_CONCEPT : {
         return action.payload;
      }
      
      case SELECTED_CUSTOMER : {
         return action.payload;
      }

      case CHANGE_INPUT_VALUE_NOTES : {
         return action.payload;
      }

      case LIST_DOCUMENTS_BY_TYPE : {
         return action.payload;
      }

      case GET_DOCUMENT_INFORMATION : {
         return action.payload;
      }

      case OPEN_CLOSE_MODAL : {
         return action.payload;
      }

      case CHANGE_VALUE_SETTINGS : {
         return action.payload;
      }

      case ACTIVATE_QUANTITY_CONCEPT : {
         return action.payload;
      }

      case ACTIVATE_EXCHANGE_RATE : {
         return action.payload;
      }

      case CHANGE_EXCHANGE_RATE : {
         return action.payload;
      }

      case DISABLED_CONCEPT : {
         return action.payload;
      }

      case DISABLED_GENERAL_CONCEPT : {
         return action.payload;
      }

      case GET_CONCEPTS_LIKE_TREE : {
         return action.payload;
      }

      case UPDATE_STATE_CONCEPTS_TREE : {
         return action.payload;
      }

      case ASIGN_NEW_CONCEPT : {
         return action.payload;
      }

      case CHANGE_VALUE_SPECIAL_INPUT : {
         return action.payload;
      }

      case SAVE_NEW_DOCUMENT : {
         return action.payload;
      }

      case MOVE_POSITION_CONCEPT : {
         return action.payload;
      }

      case DELETE_DOCUMENT : {
         return action.payload;
      }

      case MOVE_POSITION_GENERAL_CONCEPT : {
         return action.payload;
      }

      case CHANGE_OPTION_SELECT_ISABI : {
         return action.payload;
      }

      case GET_CONCEPTS_DISCOUNTS : {
         return action.payload;
      }

      case CHANGE_STATE_CONCEPTS_DISCOUNTS : {
         return action.payload;
      }

      case ASIGN_NEW_CONCEPT_DISCOUNT : {
         return action.payload;
      }

      case CHANGE_VALUE_CONCEPT_DISCOUNT : {
         return action.payload;
      }

      case CHANGE_POSITION_CONCEPTS_DISCOUNT : {
         return action.payload;
      }

      case OPEN_CLOSE_MODAL_PAYMENT : {
         return action.payload;
      }

      case CHANGE_VALUES_INPUTS_PAYMENT : {
         return action.payload;
      }

      case SAVE_PAYMENT_DOCUMENT : {
         return action.payload;
      }

      case GET_DETAILS_PAYMENT_DOCUMENT : {
         return action.payload;
      }

      case CONFIRM_PAYMENT_DOCUMENT : {
         return action.payload;
      }

      case LOAD_INFO_PAYMENT_FORM : {
         return action.payload;
      }

      case UPLOAD_PICTURE_PAYMENT : {
         return action.payload;
      }

      case DELETE_PAYMENT : {
         return action.payload;
      }
      
      case FILTER_DOCUMENTS_BY_RANGE_DATES : {
         return action.payload;
      }

      case CHANGE_SEARCH_INPUT_TABLE : {
         return action.payload;
      }

      case RESET_SEARCH_INPUT_TABLE : {
         return action.payload;
      }

      case FILTER_DOCUMENTS_BY_STATUS : {
         return action.payload;
      }

      case CHANGE_ACCOUNT_BANK : {
         return action.payload;
      }
 
     default :
     return state;
   }
}